import axios from 'axios'
import { Decode } from '@/services'

const GetToken = () => {
  if (localStorage.getItem('oneData') !== null) {
    const oneData = JSON.parse(Decode.decode(localStorage.getItem('oneData')))
    const auth = {
      headers: { Authorization: `Bearer ${oneData.user.access_token}` }
    }
    return auth
  } else {
    const auth = ''
    return auth
  }
}

export default {
  async ListMemberLevelRank (data) {
    const auth = GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END4}api/list/member/level-rank`, data, auth)
      // console.log(response.data)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async ListMemberRanked (data) {
    const auth = GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END4}api/list/member/list_member_ranked`, data, auth)
      // console.log(response.data)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async CreateMember (data) {
    const auth = GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END4}api/member/create-member`, data, auth)
      // console.log(response.data)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async DropdownPrivilege (data) {
    const auth = GetToken()
    try {
      var response = await axios.get(`${process.env.VUE_APP_BACK_END4}api/list/member/dropdown_privilege`, data, auth)
      // console.log(response.data)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async ListMemberDetail (data) {
    const auth = GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END4}api/list/member/list_member_detail`, data, auth)
      // console.log(response.data)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async UpdateMember (data) {
    const auth = GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END4}api/member/update-member`, data, auth)
      // console.log(response.data)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async getListUserPointBySellerShopID (data) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END}api/get_list_user_point_seller_shop`, data, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async getUserMemberCrm (data) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END2}crm/get_users`, data, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async getDetailMemberCrm (data) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END2}crm/detail_member`, data, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async GrantCoupon (data) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_NEW_BACK_END2}crm/grant_coupon`, data, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async GrantPoint (data) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_NEW_BACK_END2}crm/grant_point`, data, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async DeductPoint (data) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_NEW_BACK_END2}crm/deduct_point`, data, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async RegisterShopMember (data) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_NEW_BACK_END2}crm/register_shop_member`, data, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async GetCuscodeDetail (data) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_NEW_BACK_END}api/get_cuscode_detail`, data, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async GetListOrderMember (data) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_NEW_BACK_END2}crm/get_order_list_members`, data, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async UpdateCustomDiscount (data) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_NEW_BACK_END2}crm/update_member_custom`, data, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async ExportMembers (data) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_NEW_BACK_END2}crm/export_members`, data, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async CreateCouponCrm (data) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_NEW_BACK_END2}crm/create_coupon`, data, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async CreateMemberLevel (data) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END4}api/member/create-member-level`, data, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async EditMemberLevel (data) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END4}api/member/update-member-level`, data, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async GetMemberLevelDetail (data) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END4}api/member/get-member-level-detail`, data, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async DeleteMemberLevel (data) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END4}api/member/delete-member-level`, data, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async ListCouponMember (data) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_NEW_BACK_END2}crm/list_coupon_member`, data, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async GetMemberLavelProgress (data) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_NEW_BACK_END2}crm/member_level_progress`, data, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async GetMemberPointTransactions (data) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_NEW_BACK_END2}crm/member_point_transactions`, data, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async CheckLevelPopup (data) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_NEW_BACK_END2}crm/check_level_popup`, data, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async UpdateLevelPopup (data) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_NEW_BACK_END2}crm/update_level_popup`, data, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async FollowShop (data) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END5}/v1/shop-follow/toggle`, data, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async ListMemberLevel (data) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END4}api/member/list-member-level`, data, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async GetMemberCoupon (data) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_NEW_BACK_END2}crm/list_member_level_coupons`, data, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async DashboardMember (data) {
    const auth = await GetToken(data)
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END2}crm/member_monitor/overview`, data, auth)
      // var response = await axios.post('https://cannabis-debtor-reprocess.ngrok-free.dev/crm/member_monitor/overview, data, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async GetMemberShopMine (data) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_NEW_BACK_END2}crm/member_shops_mine`, data, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async GetMemberBenefit (data) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_NEW_BACK_END2}crm/member_privileges`, data, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async GetMemberProduct (data) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_NEW_BACK_END2}crm/member_products`, data, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async GetMemberActivities (data) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_NEW_BACK_END2}crm/member_announcements`, data, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async GetMemberShopOpen (data) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_NEW_BACK_END2}crm/member_shops_open`, data, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async GetLevelBenefit (data) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_NEW_BACK_END2}crm/level_benefit_list`, data, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async CreateAnnouncement (data) {
    const auth = await GetToken(data)
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END2}crm/create_announcement`, data, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async DetailAnnouncement (data) {
    const auth = await GetToken(data)
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END2}crm/detail_announcement`, data, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async UpdateAnnouncement (data) {
    const auth = await GetToken(data)
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END2}crm/update_announcement`, data, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async ListAnnouncement (data) {
    const auth = await GetToken(data)
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END2}crm/list_announcement`, data, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async DeleteAnnouncement (data) {
    const auth = await GetToken(data)
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END2}crm/delete_announcement`, data, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async CreateLevelCoupon (data) {
    const auth = await GetToken(data)
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END2}crm/level_coupon_create`, data, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async DetailCouponLevel (data) {
    const auth = await GetToken(data)
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END2}crm/level_coupon_detail`, data, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async UpdateLevelCoupon (data) {
    const auth = await GetToken(data)
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END2}crm/level_coupon_update`, data, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async ListLevelCoupon (data) {
    const auth = await GetToken(data)
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END2}crm/level_coupon_web_list`, data, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async StatusLevelCoupon (data) {
    const auth = await GetToken(data)
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END2}crm/level_coupon_status`, data, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async DeleteLevelCoupon (data) {
    const auth = await GetToken(data)
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END2}crm/level_coupon_delete`, data, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async ExportMember (data) {
    const auth = await GetToken(data)
    var response = await axios.post(`${process.env.VUE_APP_BACK_END2}report/export-member`, data, {
      ...auth,
      responseType: 'blob'
    })
    return response.data
  },
  async TemplateLevelCoupon (data) {
    const auth = GetToken()
    try {
      const response = await axios.post(`${process.env.VUE_APP_BACK_END2}crm/level_coupon_template`, data, {
        ...auth,
        responseType: 'blob'
      })
      const contentType = response.data.type || response.headers['content-type'] || ''
      if (contentType.includes('json')) {
        return JSON.parse(await response.data.text())
      }
      return response.data
    } catch (error) {
      if (!error.response) throw error
      const responseData = error.response.data
      if (responseData instanceof Blob) {
        try {
          return JSON.parse(await responseData.text())
        } catch (parseError) {
          return { code: error.response.status, message: 'ไม่สามารถดาวน์โหลด template ได้' }
        }
      }
      return responseData
    }
  },
  async ImportLevelCoupon (data) {
    const auth = GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END2}crm/level_coupon_import`, data, auth)
      return response.data
    } catch (error) {
      if (!error.response) throw error
      return error.response.data
    }
  },
  async MonitorShopOpened (data) {
    const auth = GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END2}crm/member_monitor/shop_opened`, data, auth)
      return response.data
    } catch (error) {
      if (!error.response) throw error
      return error.response.data
    }
  },
  async MembershipTotal (data) {
    const auth = GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END2}crm/member_monitor/membership_total`, data, auth)
      return response.data
    } catch (error) {
      if (!error.response) throw error
      return error.response.data
    }
  },
  async MembershipUnique (data) {
    const auth = GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END2}crm/member_monitor/membership_unique`, data, auth)
      return response.data
    } catch (error) {
      if (!error.response) throw error
      return error.response.data
    }
  },
  async OrdersByMember (data) {
    const auth = GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END2}crm/member_monitor/orders_by_member`, data, auth)
      return response.data
    } catch (error) {
      if (!error.response) throw error
      return error.response.data
    }
  },
  async OrdersByShop (data) {
    const auth = GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END2}crm/member_monitor/orders_by_shop`, data, auth)
      return response.data
    } catch (error) {
      if (!error.response) throw error
      return error.response.data
    }
  },
  async GetMembersDashboard (data) {
    const auth = GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END2}crm/get_members_dashboard`, data, auth)
      return response.data
    } catch (error) {
      if (!error.response) throw error
      return error.response.data
    }
  },
  async UpdateBirthdatePopup (data) {
    const auth = GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END2}crm/update_birthdate_popup`, data, auth)
      return response.data
    } catch (error) {
      if (!error.response) throw error
      return error.response.data
    }
  },
  async checkTypeSpecialDeal (data) {
    const auth = GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END2}crm/special_deal/type`, data, auth)
      return response.data
    } catch (error) {
      if (!error.response) throw error
      return error.response.data
    }
  },
  async MemberSpecialDeals (data) {
    const auth = GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END2}crm/member_special_deals`, data, auth)
      return response.data
    } catch (error) {
      if (!error.response) throw error
      return error.response.data
    }
  },
  async SpecialDealsMode (data) {
    const auth = GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END4}api/special_deal/setting`, data, auth)
      return response.data
    } catch (error) {
      if (!error.response) throw error
      return error.response.data
    }
  },
  async SpecialDealsSetting (data) {
    const auth = GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END4}api/special_deal/setting/lock`, data, auth)
      return response.data
    } catch (error) {
      if (!error.response) throw error
      return error.response.data
    }
  },
  async SpecialDealsList (data) {
    const auth = GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END4}api/special_deal/list`, data, auth)
      return response.data
    } catch (error) {
      if (!error.response) throw error
      return error.response.data
    }
  },
  async SpecialDealsDetail (data) {
    const auth = GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END4}api/special_deal/detail`, data, auth)
      return response.data
    } catch (error) {
      if (!error.response) throw error
      return error.response.data
    }
  },
  async SpecialDealsCreate (data) {
    const auth = GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END4}api/special_deal/create`, data, auth)
      return response.data
    } catch (error) {
      if (!error.response) throw error
      return error.response.data
    }
  },
  async SpecialDealsUpdate (data) {
    const auth = GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END4}api/special_deal/update`, data, auth)
      return response.data
    } catch (error) {
      if (!error.response) throw error
      return error.response.data
    }
  },
  async SpecialDealsStatus (data) {
    const auth = GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END4}api/special_deal/update_status`, data, auth)
      return response.data
    } catch (error) {
      if (!error.response) throw error
      return error.response.data
    }
  },
  async SpecialDealsDelete (data) {
    const auth = GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END4}api/special_deal/delete`, data, auth)
      return response.data
    } catch (error) {
      if (!error.response) throw error
      return error.response.data
    }
  },
  async SpecialDealsProductList (data) {
    const auth = GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END4}api/special_deal/product/list`, data, auth)
      return response.data
    } catch (error) {
      if (!error.response) throw error
      return error.response.data
    }
  },
  async SpecialDealsBuyerList (data) {
    const auth = GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END4}api/special_deal/buyer/list`, data, auth)
      return response.data
    } catch (error) {
      if (!error.response) throw error
      return error.response.data
    }
  },
  async SpecialDealsLevelList (data) {
    const auth = GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END4}api/special_deal/level/list`, data, auth)
      return response.data
    } catch (error) {
      if (!error.response) throw error
      return error.response.data
    }
  },
  async SpecialDealsCheckTypeOptions (data) {
    const auth = GetToken()
    try {
      var response = await axios.get(`${process.env.VUE_APP_BACK_END2}check_special_deals/type_options`, { ...auth, params: data })
      return response.data
    } catch (error) {
      if (!error.response) throw error
      return error.response.data
    }
  },
  async ShopAdsDetail (data) {
    const auth = GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END2}crm/shop_ads_detail`, data, auth)
      return response.data
    } catch (error) {
      if (!error.response) throw error
      return error.response.data
    }
  },
  async ShopAdsUpdate (data) {
    const auth = GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END2}crm/shop_ads_update`, data, auth)
      return response.data
    } catch (error) {
      if (!error.response) throw error
      return error.response.data
    }
  },
  async ShopAdsDelete (data) {
    const auth = GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END2}crm/shop_ads_delete`, data, auth)
      return response.data
    } catch (error) {
      if (!error.response) throw error
      return error.response.data
    }
  },
  async GetShopADS (data) {
    const auth = GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END2}crm/get_shop_ads`, data, auth)
      return response.data
    } catch (error) {
      if (!error.response) throw error
      return error.response.data
    }
  },
  async MemberShopSearch (data) {
    const auth = GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END2}crm/member_shops_search`, data, auth)
      return response.data
    } catch (error) {
      if (!error.response) throw error
      return error.response.data
    }
  }
}
